module.exports = __webpack_public_path__ + "static/media/2022_2A3A0838.7af07a29.jpg";